import script from "./CompletionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./CompletionPopup.vue?vue&type=style&index=0&id=6ab3f5ab&lang=scss"
import "./CompletionPopup.vue?vue&type=style&index=1&id=6ab3f5ab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab3f5ab"]])

export default __exports__